import {
  Icon,
  IconBike,
  IconCar,
  IconCopy,
  IconDeviceMobile,
  IconDotsVertical,
  IconEdit,
  IconFriends,
  IconHome,
  IconMotorbike,
  IconPhone,
  IconTableOptions,
  IconTractor,
  IconTrash,
} from '@tabler/icons-react'
import { InspectionType } from 'ai-constants'

export const InspectionTypeIcons: Record<InspectionType, Icon> = {
  cellphone: IconDeviceMobile,
  car: IconCar,
  moto: IconMotorbike,
  bike: IconBike,
  people: IconFriends,
  machinery: IconTractor,
  goods: IconHome,
  custom: IconTableOptions,
}
